import { VpDivider } from '@vtmn-play/react'
import clsx from 'clsx'
import { useRef, useState } from 'react'
import { ProductsViewHeaderCustomViewControl } from '@/components/ProductsHeader/ProductsViewHeaderCustomViewControl'
import { ProductsViewHeaderFilterControl } from '@/components/ProductsHeader/ProductsViewHeaderFilterControl'
import { ProductsViewHeaderSortControl } from '@/components/ProductsHeader/ProductsViewHeaderSortControl'
import { ProductsViewHeaderViewModeToggle } from '@/components/ProductsHeader/ProductsViewHeaderViewModeToggle'
import { ProductsViewHeaderZoomControls } from '@/components/ProductsHeader/ProductsViewHeaderZoomControls'
import { useProductsContext } from '@/contexts/products/useProductsContext'
import { useScrollContext } from '@/contexts/scroll/useScrollContext'
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver'
import './products-view-header.scss'

export function ProductsViewHeader() {
  const { customViewTarget } = useProductsContext()
  const { hideHeader, toggleHeaderVisibility } = useScrollContext()
  const [isSticky, setIsSticky] = useState(false)
  const observerRef = useRef<HTMLDivElement>(null)

  useIntersectionObserver(observerRef, hideHeader, {
    onIntersect: (entry) => {
      const nextIsSticky = !entry.isIntersecting
      setIsSticky(nextIsSticky)
      toggleHeaderVisibility(nextIsSticky)
    },
  })

  return (
    <>
      <div ref={observerRef} style={{ height: '1px', marginBottom: '-1px' }} />
      <div className={clsx('products-view-header', { 'products-view-header--sticky': isSticky })}>
        <div className="products-view-header__controls">
          <ProductsViewHeaderFilterControl />
          <VpDivider orientation="vertical" />
          <ProductsViewHeaderCustomViewControl />
          {customViewTarget === 'gallery' && <ProductsViewHeaderZoomControls />}
        </div>
        <div className="products-view-header__controls products-view-header__controls--right-aligned">
          {customViewTarget === 'gallery' && <ProductsViewHeaderViewModeToggle />}
          <ProductsViewHeaderSortControl />
        </div>
      </div>
    </>
  )
}
